module.exports = __webpack_public_path__ + "media/images/sp/stores/kyoto/kyoto_sns_01-a24fc45fdb8a2890502ba57addad5bee.jpg";